module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/plus-dbdbc30e0469a68799eb34589dccfd2d.svg";